import React from "react";
import css from './CartPage.module.css';

export const getCartErrorMessages = (setItemsError, updateCartError, removeFromCartError, fetchLineItemsError) => {
    let setItemErrorMessage = null;
    let updateCartErrorMessage = null;
    let removeFromCartErrorMessage = null;
    let fetcLineItemsErrorMessage = null;

    if (setItemsError) {
        setItemErrorMessage = 'Failed to fetch cart items, please try again!'
    }

    if (updateCartError) {
        updateCartErrorMessage = 'Failed to update the cart!'
    }

    if (removeFromCartError) {
        removeFromCartErrorMessage = 'Failed to remove item from the cart!'
    }

    if(fetchLineItemsError){
        fetcLineItemsErrorMessage = 'Failed to fetch line items!'
    }

    const setCartItemsError = setItemErrorMessage ? (
        <p className={css.errorMessage}>{setItemErrorMessage}</p>
    ) : null;

    const updateItemError = updateCartErrorMessage ? (
        <p className={css.errorMessage}>{updateCartErrorMessage}</p>
    ) : null;

    const removeItemError = removeFromCartErrorMessage ? (
        <p className={css.errorMessage}>{removeFromCartErrorMessage}</p>
    ) : null;

    const lineItemsError = fetcLineItemsErrorMessage ? (
        <p className={css.errorMessage}>{fetcLineItemsErrorMessage}</p>
    ) : null;

    return {
        setCartItemsError,
        updateItemError,
        removeItemError,
        lineItemsError,
        
    }
};